//import PatientCard from "../../components/PaitientCard/PatientCard";
import styles from "../console/Console.module.scss";
import ReortCharting from "../../components/ReportingChart/ReportingChart";
import PatientCard from "../../components/PaitientCard/PatientCard";

const ReportChart = () => {
  return (
    <>
      <div class={styles["console-main"]}>
        <div>
           {/* <PillNav /> */}
           <ReortCharting/> 
        </div>
         <PatientCard /> 
        
      </div>
    </>
  );
};

export default ReportChart;
